<template>
  <nav class="studio-mobile-navigation" v-if="studio">
    <router-link
      :to="{ name: 'studio-dashboard' }"
      class="undecorated-router-link nav-item"
      v-if="isLoggedIn"
    >
      <font-awesome-icon class="icon" :icon="['far', 'compass']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.DASHBOARD') }}
      </small>
    </router-link>
    <router-link
      :to="{ name: 'studio-home-page' }"
      class="undecorated-router-link nav-item"
      v-else
    >
      <font-awesome-icon class="icon" :icon="['far', 'compass']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.HOME') }}
      </small>
    </router-link>

    <router-link
      :to="{ name: 'studio-calendar' }"
      class="undecorated-router-link nav-item"
      v-if="studio.has_events"
    >
      <font-awesome-icon class="icon" :icon="['far', 'calendar']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.CALENDAR') }}
      </small>
    </router-link>

    <router-link
      :to="{ name: 'studio-shop' }"
      class="undecorated-router-link nav-item"
    >
      <font-awesome-icon class="icon" :icon="['far', 'box-open']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.SHOP') }}
      </small>
    </router-link>

    <router-link
      :to="{ name: 'studio-community' }"
      class="undecorated-router-link nav-item"
      v-if="isLoggedIn && studio.has_community_groups"
    >
      <font-awesome-icon class="icon" :icon="['far', 'comments']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.COMMUNITY') }}
      </small>
    </router-link>

    <div
      @click="openSettings"
      class="undecorated-router-link nav-item"
      v-if="hasCustomNavLinks"
    >
      <font-awesome-icon class="icon" :icon="['far', 'bars']" />
      <small class="mt-1 smallest">
        {{ $t('STUDIO.LINKS.MENU') }}
      </small>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'StudioMobileNavigation',
  computed: {
    ...mapGetters({
      studio: 'studio/currentStudio',
      hasCustomNavLinks: 'studio/hasCustomNavLinks',
      isLoggedIn: 'user/isLoggedIn',
    }),
  },
  methods: {
    openSettings() {
      this.$store.dispatch('globals/openMainNav', true);
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

nav {
  display: flex;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid $light-gray;
  z-index: 1032;
}

.nav-item {
  display: flex;
  height: 70px;
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: $charcoal;

  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.5);
  + .nav-item {
    // border-left: 1px solid $light-gray;
  }
}

.nav-item.router-link-exact-active {
  color: var(--brand-color, $coral);
}

.icon {
  font-size: 22px;
}
</style>
